import { useEffect } from 'react';
import { useFormatters } from '@/hooks/useFormatters';
import { setDisplayContext } from '@/utils/format-locale';

/**
 * Hands the active language and the scope currency to the non-React money
 * helpers (`formatMoney`, `formatCurrency`, `formatEGP`), so a string built
 * outside a component follows the same rule as `<Money>`. Renders nothing.
 */
export function DisplayContextSync() {
  const { locale, currency } = useFormatters();
  // Set during render as well as in the effect: the first paint must already
  // use the right currency, and the setter is idempotent.
  setDisplayContext({ locale, currency });
  useEffect(() => {
    setDisplayContext({ locale, currency });
  }, [locale, currency]);
  return null;
}
